import ReactDOM from 'react-dom';
import { AppContextProvider } from '../../Services/AppContext';
import { loadDOMComponent } from '../../helpers';
import TestFormContainer from './TestFormContainer';

loadDOMComponent({
	selector: 'react-test-form',
	callback: ({ container }) => {
		const onSubmitLink = container.getAttribute('data-onSubmit');

		ReactDOM.render(
			<AppContextProvider>
				<TestFormContainer onSubmitLink={onSubmitLink} />
			</AppContextProvider>,
			container,
		);
	},
});
